import React from 'react';
import { FileText, Award, ShieldCheck, Shield } from 'lucide-react';
import { trustIndicators } from '../utils/mockData';

const iconMap = {
  'file-text': FileText,
  award: Award,
  'shield-check': ShieldCheck,
  shield: Shield
};

export const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Why Choose <span className="text-green-400">Samaniega's Landscaping?</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Professional, trusted, and committed to excellence
            </p>
          </div>

          {/* Trust Indicators Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {trustIndicators.map((indicator) => {
              const IconComponent = iconMap[indicator.icon];
              return (
                <div 
                  key={indicator.id}
                  className="group text-center"
                >
                  <div className="flex items-center justify-center mb-6">
                    <div className="relative">
                      <div className="w-24 h-24 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <IconComponent className="h-12 w-12 text-black" />
                      </div>
                      <div className="absolute inset-0 w-24 h-24 rounded-full bg-green-400 animate-ping opacity-20"></div>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white group-hover:text-green-400 transition-colors">
                    {indicator.title}
                  </h3>
                </div>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-green-500/10 border border-green-500/30 rounded-lg px-8 py-6">
              <p className="text-lg text-gray-300 mb-2">
                Serving Washington State with pride and professionalism
              </p>
              <p className="text-2xl font-bold text-green-400">
                Your Satisfaction is Our Priority
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
